import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SubscriptionAlert } from '../../models/subscription-alert.model';
import { AlertMessage } from 'app/models/alert.model';

export const SubscriptionAlertsActions = createActionGroup({
  source: 'Subscription Alerts',
  events: {
    'Create Alert': props<{ message: AlertMessage; isPermanent: boolean }>(),
    'Add Alert': props<{ alert: SubscriptionAlert }>(),
    'Reinit Permanent Alert': emptyProps(),
    'Replace Permanent Alert': props<{ alert: SubscriptionAlert | null }>(),
    'Delete Alert': props<{ alertId: number }>(),
    'Delete Temporary Alerts': emptyProps(),
  },
});
